import { Grid, Typography, TypographyProps } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import MainContainer from '@ecm/ui/element/MainContainer'

export type CustomerLogo = {
  height: number
  name: string
  width: number
}

const defaultCustomerLogos: CustomerLogo[] = [
  {
    height: 36,
    name: 'coinbase',
    width: 160,
  },
  {
    height: 48,
    name: 'zapier',
    width: 104,
  },
  {
    height: 76,
    name: 'lyft',
    width: 96,
  },
  {
    height: 40,
    name: 'shopify',
    width: 250,
  },
  {
    height: 48,
    name: 'expensify',
    width: 168,
  },
]

const greyCustomerLogos: CustomerLogo[] = [
  {
    height: 33,
    name: 'coinbase-grey',
    width: 178,
  },
  {
    height: 60,
    name: 'zapier-grey',
    width: 130,
  },
  {
    height: 60,
    name: 'lyft-grey',
    width: 72,
  },
  {
    height: 50,
    name: 'shopify-grey',
    width: 180,
  },
  {
    height: 35,
    name: 'expensify-grey',
    width: 280,
  },
]

type OurCustomersBlockProps = {
  greyIcons?: boolean
  title?: string
  showTitle?: boolean
  variant?: TypographyProps['variant']
}

const OurCustomersBlock = ({
  greyIcons,
  title = 'Thousands of companies have trusted us with over 21 million pieces of mail and $3.1 billion in checks',
  showTitle = true,
  variant = 'h5',
}: OurCustomersBlockProps) => {
  const customerLogos = greyIcons ? greyCustomerLogos : defaultCustomerLogos

  return (
    <MainContainer sx={{ paddingY: '3em' }}>
      {showTitle && (
        <Typography variant={variant} component="h2" textAlign="center">
          {title}
        </Typography>
      )}
      <Grid
        container
        justifyContent="space-around"
        alignItems="center"
        spacing={4}
        padding="1.5em 0 0"
        direction={{ sm: 'row', xs: 'column' }}
      >
        {customerLogos.map(({ name, ...props }) => (
          <Grid key={name} item>
            <CloudflareImage src={`/images/logo/${name}.svg`} {...props} />
          </Grid>
        ))}
      </Grid>
    </MainContainer>
  )
}

export default OurCustomersBlock
